import { Box } from "@skailer-com/uikit";
import { CSSProperties, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type EventViewMode = "ultrashort" | "short" | "full";
const boxCommon = "w-full items-center whitespace-nowrap text-ellipsis overflow-hidden";
const theme = {
  title: {
    ultrashort: "after:content-[','] after:pr-0.25 inline-flex items-center",
    short: "after:content-[','] after:pr-1 inline-flex items-center font-semibold",
    full: "text-base flex font-semibold",
  },
  time: {
    ultrashort: "pl-1",
    short: "inline whitespace-nowrap text-ellipsis overflow-hidden",
    full: "block text-base opacity-60 whitespace-nowrap text-ellipsis overflow-hidden",
  },
  box: {
    ultrashort: `px-1 py-0 text-[10px] leading-[12px] inline-flex ${boxCommon}`,
    short: `px-1 py-1 inline-flex ${boxCommon}`,
    full: `px-1 py-0.5 ${boxCommon}`,
  },
};

export interface CalendarEventCardProps {
  durationMinutes: number;
  title?: ReactNode;
  time?: string;
  appearanceClassName?: string;
  style?: CSSProperties;
  withMarker?: boolean;
  onClick?: () => void;
}

export function CalendarEventCard({
  durationMinutes,
  title,
  time,
  appearanceClassName,
  style,
  withMarker = true,
  onClick,
}: CalendarEventCardProps) {
  const mode: EventViewMode =
    durationMinutes < 30 ? "ultrashort" : durationMinutes < 60 ? "short" : "full";
  return (
    <Box
      onClick={onClick}
      className={twMerge(
        "flex h-full rounded-xs cursor-pointer",
        theme.box[mode],
        appearanceClassName
      )}
      style={style}
    >
      {withMarker && (
        <div className="absolute left-1 top-1 bottom-1 w-1 rounded-xs bg-brand-dark" />
      )}
      <div className={twMerge(withMarker && "ml-1", theme.box[mode])}>
        {title && <div className={theme.title[mode]}>{title}</div>}
        {time && <span className={theme.time[mode]}>{time}</span>}
      </div>
    </Box>
  );
}
